import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {GameUtils} from "../utils/GameUtils";
import {Sound} from "../sound/Sound";

export class XGodRunner implements SimplePresentationRunner {
    shouldRun(): boolean {
        return Game.model.isXGodMaxWinTriggered();
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.delay(0.3);
        tl.add(() => {
            flowStateController.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });

        const xGodBigSym: PIXI.spine.Spine = new PIXI.spine.Spine(Game.assetLoader.getSpineAsset("xGodBigSym"));
        xGodBigSym.position.set(360, 415);
        tl.add(() => {
            Game.foregroundElements.featureLogoContainer.playXGodActive();
            Game.effectsView.addChild(xGodBigSym);
        });
        tl.add(GameUtils.createTimelineForAnimation(xGodBigSym, 0, "land", false));
        tl.add(()=>{
            Game.keypadPlugin.hide(0.1);
            Game.soundPlayer.playSound(Sound.X_GOD_MEGA_SYMBOL_REVEAL);
        },"<");
        tl.add(GameUtils.shake(0, 10, 60 * 4, 5, 0.3), 0.2);
        tl.add(() => {
            Game.reelView.hide(0.01);
        }, 0.1);

        //tl.to(xGodBigSym, {alpha : 0, duration: 0.5}, 1.6);
        tl.add(()=>{
            Game.blackBG.show(1);
        }, 1.9);
        tl.to({}, {duration: 0.3});
        tl.add(() => {
            flowStateController.finish();
        });

        tl.to(xGodBigSym, {
            duration: 0.1, alpha: 0, onComplete: () => {
                xGodBigSym.parent?.removeChild(xGodBigSym);
                Game.blackBG.hide(0.01);
            }
        }, "+=0.6"); // #353, this time is intentional, because win cap view gets fully visible in 0.6sec
    }

    private onSkip(tl: gsap.core.Timeline) {
        tl.timeScale(2);
    }

}